export default __webpack_public_path__ + "static/media/line-bg2.3589f4d7.png";